import React from 'react';
import { useTranslation } from "react-i18next";
import { Grid } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import DyanamicDropdown from 'components/Elements/DynamicDropdown';
import { useFilters } from '../FilterContext';
import { useServiceStatuses, GROUP_MEMBERS } from './hooks/useServiceStatuses';
import { useFilterInitialization } from './hooks/useFilterInitialization';
import { SHOW_ALL_OPTION } from '../constants';

export const ServiceStatusFilter = () => {
  const { t } = useTranslation();
  const { filterValues, updateFilter, isShowAll } = useFilters();
  const showAllEnabled = isShowAll('serviceStatus');
  const serviceStatuses = useServiceStatuses(showAllEnabled);

  const buildParams = (item) => {
    if (item.id === 1 || item.id === 2) {
      return { status: "", statusType: item.id === 1 ? "C" : "O" };
    }
    if (item.id === "") {
      return { status: "", statusType: "" };
    }
    return { status: item.id, statusType: "" };
  };
  const buildReportParams = (item) => {
    if (item.id === 1 || item.id === 2) {
      return { statusType: item.id === 1 ? "C" : "O" };
    }
    if (item.id === "") {
      return {};
    }
    return { statuses: [item.id] };
  };

  useFilterInitialization('serviceStatus', serviceStatuses, {
    waitForData: true,
    persistAll: true,
    getDefaultValue: () => GROUP_MEMBERS.find(member => member.statusType === "O"),
    getParams: buildParams,
    getReportParams: buildReportParams,
  });

  if (!filterValues.serviceStatus) {
    return null;
  }

  return (
    <Grid item lg={3} md={6} xs={12}>
      <DyanamicDropdown
        dataSource={serviceStatuses}
        columns={[{ name: 'name', id: 1, minWidth: '130px' }]}
        columnsMinWidths={[140, 140, 140, 140, 140]}
        showHeader={false}
        width="100%"
        placeholder={t("placeholder.selectStatus")}
        onChange={item => updateFilter('serviceStatus', item, buildParams(item), true, buildReportParams(item))}
        selectdValueToshow="name"
        selectedValue={filterValues.serviceStatus?.value}
        label={t("label.filterByStatus")}
        isServerSide={false}
        icon={<FilterListIcon style={{ color: 'rgb(48, 122, 215)' }} />}
        required={false}
        showBorderColor
        groupBy={[
          { ...SHOW_ALL_OPTION, statusType: "" },
          ...GROUP_MEMBERS,
        ]}
        hasGroup
      />
    </Grid>
  );
}; 
